import { useActiveLayerContext } from '@/context/__project__/ActiveLayerContext'
import { useBuilderActionContextV2 } from '@/context/__project__/BuilderActionContextV2'
import { useCompBackgroundColor, useCompContext, useCompFormContext } from '@/context/__project__/CompContext'

import { CompButtonWrapperCore } from '../core/button/wrapper'
import { CompButton } from './CompButton'

function CompButtonWrapper() {
  // infos
  const compContext = useCompContext()
  const { currentParentBg } = useCompBackgroundColor()
  const { activeLayer } = useActiveLayerContext()
  const infosProps = { ...compContext, activeLayer, currentParentBg }

  // action
  const actionContext = useBuilderActionContextV2()

  // form
  const formContext = useCompFormContext()

  return (
    <CompButtonWrapperCore infos={infosProps} action={actionContext} form={formContext}>
      {(childrenProps, ref) => <CompButton {...childrenProps} ref={ref} />}
    </CompButtonWrapperCore>
  )
}

export default CompButtonWrapper
